/**
 * Plain (non-React) toast wrapper over react-toastify.
 *
 * The app-wide notify mechanism — components and non-component code (the Zustand
 * stores, services) alike import { notify }. The default options give every
 * toast a consistent look; per-call `opts` are layered on top (e.g.
 * `{ position: 'top-center', autoClose: false }`).
 *
 * The `toast[type]?.(...)` form dispatches to toast.success / .error / .info /
 * .warning by name; an unknown type is a no-op.
 */
import { toast, type ToastContent, type ToastOptions } from "react-toastify";

/** The toast variants `notify` dispatches to (each a method on `toast`). */
type NotifyType = "success" | "error" | "info" | "warning";

const DEFAULT_OPTIONS: ToastOptions = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

export const notify = (type: NotifyType, message: ToastContent, opts?: ToastOptions) =>
  toast[type]?.(message, { ...DEFAULT_OPTIONS, ...opts });
